__turbopack_context__.v({
  "button": "pagination-module-scss-module__EoVoQa__button",
  "button--icon": "pagination-module-scss-module__EoVoQa__button--icon",
  "button--icon--selected": "pagination-module-scss-module__EoVoQa__button--icon--selected",
  "button--inverted": "pagination-module-scss-module__EoVoQa__button--inverted",
  "button--plain": "pagination-module-scss-module__EoVoQa__button--plain",
  "button--secondary": "pagination-module-scss-module__EoVoQa__button--secondary",
  "button--small": "pagination-module-scss-module__EoVoQa__button--small",
  "button--tertiary": "pagination-module-scss-module__EoVoQa__button--tertiary",
  "button-wrapper": "pagination-module-scss-module__EoVoQa__button-wrapper",
  "button__icon-next": "pagination-module-scss-module__EoVoQa__button__icon-next",
  "button__prefix": "pagination-module-scss-module__EoVoQa__button__prefix",
  "button__suffix": "pagination-module-scss-module__EoVoQa__button__suffix",
  "pagination": "pagination-module-scss-module__EoVoQa__pagination",
  "pagination__item-range": "pagination-module-scss-module__EoVoQa__pagination__item-range",
});
